/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillPaymentInfoVo } from './BillPaymentInfoVo';
import {
    BillPaymentInfoVoFromJSON,
    BillPaymentInfoVoFromJSONTyped,
    BillPaymentInfoVoToJSON,
    BillPaymentInfoVoToJSONTyped,
} from './BillPaymentInfoVo';

/**
 * 
 * @export
 * @interface BillItem
 */
export interface BillItem {
    /**
     * ID
     * @type {number}
     * @memberof BillItem
     */
    id?: number;
    /**
     * 账单类型
     * @type {number}
     * @memberof BillItem
     */
    billType?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof BillItem
     */
    orderCode?: string;
    /**
     * 订单ID
     * @type {number}
     * @memberof BillItem
     */
    orderId?: number;
    /**
     * 汇率
     * @type {number}
     * @memberof BillItem
     */
    exchangeRate?: number;
    /**
     * 计算货物运费的单位
     * @type {number}
     * @memberof BillItem
     */
    applyUnit?: number;
    /**
     * 适用货物运费的值
     * @type {number}
     * @memberof BillItem
     */
    applyValue?: number;
    /**
     * 货物收费总金额
     * @type {number}
     * @memberof BillItem
     */
    totalGoodsAmount?: number;
    /**
     * 附加服务总金额
     * @type {number}
     * @memberof BillItem
     */
    totalAdditionalServiceAmount?: number;
    /**
     * 钱包转账总金额
     * @type {number}
     * @memberof BillItem
     */
    totalTransferAmount?: number;
    /**
     * 账单总金额
     * @type {number}
     * @memberof BillItem
     */
    totalAmount?: number;
    /**
     * 卡号
     * @type {string}
     * @memberof BillItem
     */
    cardNumber?: string;
    /**
     * 卡类型
     * @type {number}
     * @memberof BillItem
     */
    cardType?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof BillItem
     */
    currencyCode?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof BillItem
     */
    userId?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof BillItem
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof BillItem
     */
    userCode?: string;
    /**
     * 账单名
     * @type {string}
     * @memberof BillItem
     */
    name?: string;
    /**
     * 账单状态
     * @type {number}
     * @memberof BillItem
     */
    status?: number;
    /**
     * 是否可用
     * @type {number}
     * @memberof BillItem
     */
    enable?: number;
    /**
     * 账单编号
     * @type {string}
     * @memberof BillItem
     */
    billCode?: string;
    /**
     * 卡所在银行名称
     * @type {string}
     * @memberof BillItem
     */
    cardBankName?: string;
    /**
     * 持卡人姓名
     * @type {string}
     * @memberof BillItem
     */
    cardHolderName?: string;
    /**
     * 备注
     * @type {string}
     * @memberof BillItem
     */
    remark?: string;
    /**
     * 创建账单的管理员ID
     * @type {number}
     * @memberof BillItem
     */
    createStaffId?: number;
    /**
     * 客户商业类型：1-企业，2-个人
     * @type {number}
     * @memberof BillItem
     */
    userBusinessType?: number;
    /**
     * 账单关联实体ID
     * @type {number}
     * @memberof BillItem
     */
    targetId?: number;
    /**
     * 仓库ID（订单创建账单时归属的仓库；钱包操作类账单为空）
     * @type {number}
     * @memberof BillItem
     */
    warehouseId?: number;
    /**
     * 退款金额
     * @type {number}
     * @memberof BillItem
     */
    returnAmount?: number;
    /**
     * 关联账单编号列表（用当前账单id作为target_id检索billType=28的公共退款账单编号）
     * @type {Array<string>}
     * @memberof BillItem
     */
    relatedBillCodes?: Array<string>;
    /**
     * 退款账单编号列表（通过订单编号检索同订单下billType=4/20/24的有效退款账单编号，当前账单为退款类型时为空）
     * @type {Array<string>}
     * @memberof BillItem
     */
    refundBillCodes?: Array<string>;
    /**
     * 创建时间
     * @type {string}
     * @memberof BillItem
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof BillItem
     */
    updateTime?: string;
    /**
     * 
     * @type {BillPaymentInfoVo}
     * @memberof BillItem
     */
    paymentInfo?: BillPaymentInfoVo;
}

/**
 * Check if a given object implements the BillItem interface.
 */
export function instanceOfBillItem(value: object): value is BillItem {
    return true;
}

export function BillItemFromJSON(json: any): BillItem {
    return BillItemFromJSONTyped(json, false);
}

export function BillItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'exchangeRate': json['exchangeRate'] == null ? undefined : json['exchangeRate'],
        'applyUnit': json['applyUnit'] == null ? undefined : json['applyUnit'],
        'applyValue': json['applyValue'] == null ? undefined : json['applyValue'],
        'totalGoodsAmount': json['totalGoodsAmount'] == null ? undefined : json['totalGoodsAmount'],
        'totalAdditionalServiceAmount': json['totalAdditionalServiceAmount'] == null ? undefined : json['totalAdditionalServiceAmount'],
        'totalTransferAmount': json['totalTransferAmount'] == null ? undefined : json['totalTransferAmount'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'billCode': json['billCode'] == null ? undefined : json['billCode'],
        'cardBankName': json['cardBankName'] == null ? undefined : json['cardBankName'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createStaffId': json['createStaffId'] == null ? undefined : json['createStaffId'],
        'userBusinessType': json['userBusinessType'] == null ? undefined : json['userBusinessType'],
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'returnAmount': json['returnAmount'] == null ? undefined : json['returnAmount'],
        'relatedBillCodes': json['relatedBillCodes'] == null ? undefined : json['relatedBillCodes'],
        'refundBillCodes': json['refundBillCodes'] == null ? undefined : json['refundBillCodes'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'paymentInfo': json['paymentInfo'] == null ? undefined : BillPaymentInfoVoFromJSON(json['paymentInfo']),
    };
}

export function BillItemToJSON(json: any): BillItem {
    return BillItemToJSONTyped(json, false);
}

export function BillItemToJSONTyped(value?: BillItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'billType': value['billType'],
        'orderCode': value['orderCode'],
        'orderId': value['orderId'],
        'exchangeRate': value['exchangeRate'],
        'applyUnit': value['applyUnit'],
        'applyValue': value['applyValue'],
        'totalGoodsAmount': value['totalGoodsAmount'],
        'totalAdditionalServiceAmount': value['totalAdditionalServiceAmount'],
        'totalTransferAmount': value['totalTransferAmount'],
        'totalAmount': value['totalAmount'],
        'cardNumber': value['cardNumber'],
        'cardType': value['cardType'],
        'currencyCode': value['currencyCode'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'name': value['name'],
        'status': value['status'],
        'enable': value['enable'],
        'billCode': value['billCode'],
        'cardBankName': value['cardBankName'],
        'cardHolderName': value['cardHolderName'],
        'remark': value['remark'],
        'createStaffId': value['createStaffId'],
        'userBusinessType': value['userBusinessType'],
        'targetId': value['targetId'],
        'warehouseId': value['warehouseId'],
        'returnAmount': value['returnAmount'],
        'relatedBillCodes': value['relatedBillCodes'],
        'refundBillCodes': value['refundBillCodes'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'paymentInfo': BillPaymentInfoVoToJSON(value['paymentInfo']),
    };
}

